"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cleanDatabasePath_1 = __importDefault(require("../FirebaseDatabaseCache/cleanDatabasePath"));
const updateDatabaseCache_1 = __importDefault(require("../FirebaseDatabaseCache/updateDatabaseCache"));
const addControlsToParent_1 = __importDefault(require("../functions/controlOperations/addControlsToParent"));
const updateControlById_1 = __importDefault(require("../functions/controlOperations/updateControlById"));
const flatBuildOrdersControls_1 = __importDefault(require("../functions/flatters/flatBuildOrdersControls"));
const cleanUndefinedFromValue_1 = __importDefault(require("../shared/cleanUndefinedFromValue"));
const getValueByPathFromUnknown_1 = __importDefault(require("../shared/getValueByPathFromUnknown"));
const setObjectPropByPath_1 = __importDefault(require("../shared/setObjectPropByPath"));
const setValueLikeFirebase_1 = __importDefault(require("../shared/setValueLikeFirebase"));
const valueIsArray_1 = __importDefault(require("../typeAssertions/valueIsArray"));
const valueIsRecord_1 = __importDefault(require("../typeAssertions/valueIsRecord"));
const applicationStateConstants_1 = __importDefault(require("./applicationStateConstants"));
const buildApplicationStateReducer = (defaultValues) => {
    const defaultState = {
        routeStack: undefined,
        projectId: defaultValues.projectId,
        appId: defaultValues.appId,
        buildOrders: defaultValues.buildOrders,
        flattedControls: defaultValues.flattedControls,
        runningMode: defaultValues.runningMode,
        dbCache: [],
        localStorage: {
            data: defaultValues.localStorageData,
            listeners: {},
        },
        openCameraParams: undefined,
        openInputDialog: undefined,
        openAlert: undefined,
        openAdMobInterstitialAds: undefined,
        loadingPageContext: {
            isOpened: false,
            lottieUrl: undefined,
        },
        sideMenuContext: {
            isOpened: false,
        },
        bottomMenuContext: {
            isOpened: false,
        },
        customFontName: defaultValues.customFontName,
        openImageViewer: {
            urls: undefined,
            isOpened: false,
        },
    };
    return (propState, action) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const state = propState || defaultState;
        switch (action === null || action === void 0 ? void 0 : action.type) {
            case applicationStateConstants_1.default.UPDATE_ROUTE_STACK:
                return Object.assign(Object.assign({}, state), { routeStack: action.payload });
            case applicationStateConstants_1.default.RESET:
                return defaultState;
            case applicationStateConstants_1.default.BOOT:
                return Object.assign(Object.assign({}, state), { projectId: action.payload.projectId, appId: action.payload.appId, flattedControls: (0, flatBuildOrdersControls_1.default)(action.payload.buildOrders), buildOrders: action.payload.buildOrders });
            case applicationStateConstants_1.default.UPDATE_RUNNING_MODE:
                return Object.assign(Object.assign({}, state), { runningMode: action.payload });
            case applicationStateConstants_1.default.UPDATE_CONTROL_BY_ID: {
                if (!state.buildOrders || !state.flattedControls) {
                    return state;
                }
                const { control, dataToUpdate, } = action.payload;
                const { buildOrders, flattedControls } = (0, updateControlById_1.default)({
                    buildOrders: state.buildOrders,
                    flattedControls: state.flattedControls,
                    controlId: control.id,
                    dataToUpdate,
                });
                return Object.assign(Object.assign({}, state), { flattedControls,
                    buildOrders });
            }
            case applicationStateConstants_1.default.UPDATE_DB_CACHE:
                return Object.assign(Object.assign({}, state), { dbCache: (0, updateDatabaseCache_1.default)({
                        currentCacheData: state.dbCache,
                        currentTimeInMillis: Date.now(),
                        data: action.payload.data,
                        route: action.payload.route,
                    }) });
            case applicationStateConstants_1.default.OVERWRITE_DB_CACHE:
                return Object.assign(Object.assign({}, state), { dbCache: action.payload });
            case applicationStateConstants_1.default.UPDATE_LOCAL_STORAGE: {
                const updates = action.payload;
                let localDbData = state.localStorage.data;
                Object.entries(updates).forEach(([rawPath, value]) => {
                    const arrayPath = (0, cleanDatabasePath_1.default)(rawPath);
                    if ((0, valueIsArray_1.default)(value) || (0, valueIsRecord_1.default)(value)) {
                        Object.entries(value).forEach(([valueKey, subValue]) => {
                            localDbData = (0, setValueLikeFirebase_1.default)({
                                data: localDbData || {},
                                newValue: subValue,
                                path: [...arrayPath.split('/'), valueKey],
                            });
                        });
                    }
                    else {
                        localDbData = (0, setValueLikeFirebase_1.default)({
                            data: localDbData || {},
                            newValue: value,
                            path: arrayPath.split('/'),
                        });
                    }
                });
                if (localDbData) {
                    const cleanedValue = (0, cleanUndefinedFromValue_1.default)(localDbData);
                    localDbData = (0, valueIsRecord_1.default)(cleanedValue) ? cleanedValue : undefined;
                }
                return Object.assign(Object.assign({}, state), { localStorage: Object.assign(Object.assign({}, state.localStorage), { data: localDbData, lastUpdates: updates }) });
            }
            case applicationStateConstants_1.default.CLEAN_LOCAL_STORAGE:
                return Object.assign(Object.assign({}, state), { localStorage: Object.assign(Object.assign({}, state.localStorage), { data: undefined }) });
            case applicationStateConstants_1.default.BOOT_LOCAL_STORAGE:
                return Object.assign(Object.assign({}, state), { localStorage: {
                        listeners: {},
                        data: action.payload,
                    } });
            case applicationStateConstants_1.default.CLEAN_LOCAL_STORAGE_LISTENERS:
                return Object.assign(Object.assign({}, state), { localStorage: {
                        listeners: {},
                        data: state.localStorage.data,
                    } });
            case applicationStateConstants_1.default.ADD_LOCAL_STORAGE_LISTENER: {
                const currentListeners = state.localStorage.listeners[action.payload.path] || [];
                return Object.assign(Object.assign({}, state), { localStorage: Object.assign(Object.assign({}, state.localStorage), { listeners: Object.assign(Object.assign({}, state.localStorage.listeners), { [action.payload.path]: [...currentListeners, action.payload.listener] }) }) });
            }
            case applicationStateConstants_1.default.OPEN_CAMERA:
                return Object.assign(Object.assign({}, state), { openCameraParams: action.payload });
            case applicationStateConstants_1.default.UPDATE_INPUTDIALOG_CONTEXT:
                return Object.assign(Object.assign({}, state), { openInputDialog: action.payload });
            case applicationStateConstants_1.default.UPDATE_ALERT_CONTEXT:
                return Object.assign(Object.assign({}, state), { openAlert: action.payload });
            case applicationStateConstants_1.default.UPDATE_CONFIRM_ALERT_CONTEXT:
                return Object.assign(Object.assign({}, state), { openConfirmAlert: action.payload });
            case applicationStateConstants_1.default.UPDATE_ADMOB_INTERSTITIAL_CONTEXT:
                return Object.assign(Object.assign({}, state), { openAdMobInterstitialAds: action.payload });
            case applicationStateConstants_1.default.SET_IS_BOTTOM_MENU_OPENED:
                return Object.assign(Object.assign({}, state), { bottomMenuContext: {
                        isOpened: action.payload || !((_a = state.bottomMenuContext) === null || _a === void 0 ? void 0 : _a.isOpened),
                    } });
            case applicationStateConstants_1.default.SET_IS_LOADING_PAGE_OPENED:
                return Object.assign(Object.assign({}, state), { loadingPageContext: action.payload });
            case applicationStateConstants_1.default.SET_IS_SIDE_MENU_OPENED:
                return Object.assign(Object.assign({}, state), { sideMenuContext: {
                        isOpened: action.payload || !((_b = state.sideMenuContext) === null || _b === void 0 ? void 0 : _b.isOpened),
                    } });
            case applicationStateConstants_1.default.SET_TRANSITION_SIDE_MENU:
                return Object.assign(Object.assign({}, state), { sideMenuContext: {
                        isOpened: !!((_c = state.sideMenuContext) === null || _c === void 0 ? void 0 : _c.isOpened),
                        transition: (_d = action.payload) === null || _d === void 0 ? void 0 : _d.type,
                        speed: (_e = action.payload) === null || _e === void 0 ? void 0 : _e.speed,
                    } });
            case applicationStateConstants_1.default.SET_TRANSITION_BOTTOM_MENU:
                return Object.assign(Object.assign({}, state), { bottomMenuContext: {
                        isOpened: !!((_f = state.bottomMenuContext) === null || _f === void 0 ? void 0 : _f.isOpened),
                        transition: (_g = action.payload) === null || _g === void 0 ? void 0 : _g.type,
                        speed: (_h = action.payload) === null || _h === void 0 ? void 0 : _h.speed,
                    } });
            case applicationStateConstants_1.default.UPDATE_CONTROL_PROP_BY_PATH_IF_EXIST: {
                if (!state.buildOrders || !state.flattedControls) {
                    return state;
                }
                const instructions = action.payload;
                const controlInfo = (_j = state.flattedControls) === null || _j === void 0 ? void 0 : _j[instructions.controlId];
                if (!controlInfo) {
                    return state;
                }
                const { control: controlToUpdate } = controlInfo;
                if ((0, getValueByPathFromUnknown_1.default)(controlToUpdate, instructions.propPath) === instructions.value) {
                    return state;
                }
                const newObject = (0, setObjectPropByPath_1.default)(controlToUpdate, instructions.propPath, instructions.value);
                const { buildOrders, flattedControls } = (0, updateControlById_1.default)({
                    buildOrders: state.buildOrders,
                    flattedControls: state.flattedControls,
                    controlId: instructions.controlId,
                    dataToUpdate: newObject,
                });
                return Object.assign(Object.assign({}, state), { flattedControls,
                    buildOrders });
            }
            case applicationStateConstants_1.default.UPDATE_CONTROL_TO_LIST: {
                if (!state.buildOrders || !state.flattedControls) {
                    return state;
                }
                const { shouldAddTabsToList, controlId, inverted, categoryField, listItemControlTemplate, controls: listControls, listStyles, functionsToUpdate, filterEnabled, filterProperty, filterPlaceholder, listControlsInfo, isHorizontal, numColumns, } = action.payload;
                const baseControlInfo = state.flattedControls[controlId];
                if (!baseControlInfo) {
                    console.warn('The base control to generate the list was not found'); // eslint-disable-line
                    return state;
                }
                const baseControl = baseControlInfo.control;
                const controlIsList = (control) => control.tag === 'flatList' || control.tag === 'sectionList';
                const baseInnerStyle = (controlIsList(baseControl) && baseControl.contentContainerStyle)
                    || ((_k = baseControl.controls) === null || _k === void 0 ? void 0 : _k[0].style);
                const newTag = (shouldAddTabsToList && 'sectionList') || 'flatList';
                const { buildOrders: buildOrdersAfterControlUpdate, flattedControls: flattedControlsAfterControlUpdate, } = (0, updateControlById_1.default)({
                    buildOrders: state.buildOrders,
                    flattedControls: state.flattedControls,
                    controlId,
                    dataToUpdate: {
                        tag: newTag,
                        contentContainerStyle: baseInnerStyle,
                        inverted,
                        categoryField,
                        listItemControlTemplate,
                        filterEnabled,
                        filterPlaceholder,
                        listStyles,
                        filterProperty,
                        controls: listControls,
                        numColumns,
                        isHorizontal: !!isHorizontal,
                    },
                    functionsToUpdate,
                });
                return Object.assign(Object.assign({}, state), { flattedControls: Object.assign(Object.assign({}, flattedControlsAfterControlUpdate), listControlsInfo), buildOrders: buildOrdersAfterControlUpdate });
            }
            case applicationStateConstants_1.default.UPDATE_SWIPER_CONTENT: {
                if (!state.buildOrders || !state.flattedControls) {
                    return state;
                }
                const { controlId, listItemControlTemplate, controls: listControls, functionsToUpdate, } = action.payload;
                const { buildOrders: buildOrdersAfterControlUpdate, flattedControls: flattedControlsAfterControlUpdate, } = (0, updateControlById_1.default)({
                    buildOrders: state.buildOrders,
                    flattedControls: state.flattedControls,
                    controlId,
                    dataToUpdate: {
                        tag: 'Swiper',
                        isHidden: true,
                        listItemControlTemplate,
                    },
                    functionsToUpdate,
                });
                const { buildOrders: buildOrdersAfterControlsAdded, flattedControls: flattedControlsAfterControlsAdded, } = (0, addControlsToParent_1.default)({
                    buildOrders: buildOrdersAfterControlUpdate,
                    flattedControls: flattedControlsAfterControlUpdate,
                    parentId: controlId,
                    controlsToAdd: listControls,
                });
                return Object.assign(Object.assign({}, state), { flattedControls: flattedControlsAfterControlsAdded, buildOrders: buildOrdersAfterControlsAdded });
            }
            case applicationStateConstants_1.default.ADD_ITEMS_TO_FLAT_LIST: {
                if (!state.buildOrders || !state.flattedControls) {
                    return state;
                }
                const { controlId, controls: newControls, listControlsInfo, } = action.payload;
                const controlInfo = state.flattedControls[controlId];
                if (!controlInfo) {
                    return state;
                }
                const originalControls = controlInfo.control.controls || [];
                const { buildOrders: buildOrdersAfterMainUpdate, flattedControls: flattedControlsAfterMainUpdate, } = (0, updateControlById_1.default)({
                    buildOrders: state.buildOrders,
                    flattedControls: state.flattedControls,
                    controlId,
                    dataToUpdate: {
                        controls: [...originalControls, ...newControls],
                    },
                });
                return Object.assign(Object.assign({}, state), { flattedControls: Object.assign(Object.assign({}, flattedControlsAfterMainUpdate), listControlsInfo), buildOrders: buildOrdersAfterMainUpdate });
            }
            case applicationStateConstants_1.default.SET_CUSTOM_FONT_NAME: {
                return Object.assign(Object.assign({}, state), { customFontName: action.payload });
            }
            case applicationStateConstants_1.default.UPDATE_PALETTE_COLORS: {
                if (!state.buildOrders || !state.flattedControls) {
                    return state;
                }
                return Object.assign(Object.assign({}, state), { buildOrders: Object.assign(Object.assign({}, state.buildOrders), { palette: Object.assign(Object.assign({}, state.buildOrders.palette), { shadeBases: {
                                primary: action.payload.primary,
                                secondary: action.payload.secondary,
                                black: action.payload.black,
                            } }) }) });
            }
            case applicationStateConstants_1.default.OPEN_IMAGE_VIEWER: {
                return Object.assign(Object.assign({}, state), { openImageViewer: action.payload });
            }
            default:
                return state;
        }
    };
};
exports.default = buildApplicationStateReducer;
